import { useState } from "react";
import { accountService } from "@miplatform/api";
import {
  DOCUMENT_TYPES,
  ENTITY_TYPES,
  HTTP_STATUSES,
} from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { toastService } from "@miplatform/toast";
import { externalReferenceId } from "@miplatform/utils";
import { useDocumentsViewModel } from "@miplatform/view-models";

export const usePrebillPaymentInformationModalViewModel = ({
  attempt,
  invoice,
  length,
  onClose,
  onRefresh,
}) => {
  const { loading, uploadDocument, getDocumentCategories } =
    useDocumentsViewModel();
  const [file, setFile] = useState(null);
  const [documentCategory, setDocumentCategory] = useState(null);
  const stateManager = useComponentState();
  const isLoading = loading || stateManager.isBusy();

  const handleFileChange = (files) => {
    if (files?.length > 0) {
      setFile(files[0]);
    }
  };

  const resetFile = () => {
    setFile(null);
  };

  const getDocumentCategory = async () => {
    const categories = await getDocumentCategories(ENTITY_TYPES.PURCHASE_ORDER);
    if (categories?.length > 0) {
      setDocumentCategory(categories[0]);
    }
  };

  const uploadBillingCommitmentDocument = (data) =>
    uploadDocument({
      file,
      documentType: DOCUMENT_TYPES.UNKNOWN,
      category: documentCategory,
      externalReferenceId: externalReferenceId.getPurchaseOrderRefId({
        purchaseOrderId: data.id,
      }),
    });

  const addPaymentToInvoice = (data) =>
    accountService.invoices.addPayment({
      id: invoice.id,
      data: {
        billingCommitmentId: data.id,
        ...data,
      },
    });

  const createBillingCommitment = (data) => {
    stateManager.run(async () => {
      const response = await accountService.billingCommitments.create({
        data: {
          ...data,
          homeId: attempt?.home?.id,
          name: `${attempt?.assignment?.assignmentTemplateName}-${length + 1}`,
          orderId: attempt?.orderId,
          orderTemplateId: attempt?.orderTemplateId,
        },
        toastMessageConfig: {
          success: { text: "Payment Information was added successfully." },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        const [uploadResponse] = await Promise.all([
          uploadBillingCommitmentDocument(response.data),
          addPaymentToInvoice(response.data),
        ]);

        if (uploadResponse?.id) {
          toastService.success({ text: "File uploaded successfully." });
        }

        onRefresh();
        onClose();
        resetFile();
      }
    });
  };

  return {
    documentCategory,
    isLoading,
    file,
    getDocumentCategory,
    createBillingCommitment,
    handleFileChange,
    resetFile,
  };
};
